<script setup lang="ts">
import { useBreadCrumb } from '@base/composables/breadCrumb'
import type { BreadcrumbItem } from '#ui/components/Breadcrumb.vue'
import { ut_isEmbedded } from '@base/utils/utils'

const cp = useBreadCrumb()
const p = defineProps<{
  isHistoric: boolean
  realCountry: string
}>()

const breadCrumbData = computed((): BreadcrumbItem [] => {
  const breadCrumbData = cp.breadCrumbData.value
  if (!breadCrumbData) { return [] }
  // Modify the root path to not historic
  if (p.isHistoric && breadCrumbData[0]) {
    const itemTo: any = breadCrumbData[0].to as any
    const pathAr: string[] = itemTo['path'].split('/')
    if (pathAr[1]) {
      pathAr[1] = p.realCountry
    }
    itemTo['path'] = pathAr.join('/')
  }
  if (!ut_isEmbedded() && breadCrumbData[0]) {
    breadCrumbData[0].label = 'wilo'
  }
  return breadCrumbData
})
</script>

<template>
  <div v-if="breadCrumbData">
    <UBreadcrumb
      :items="breadCrumbData"
      :ui="{ linkLabel: 'text-gunmetal-2' }"
      @click="cp.deleteScrollPos()"
    >
      <template #separator>
        <span class="text-gunmetal-2">/</span>
      </template>
    </UBreadcrumb>
  </div>
</template>
